webpackJsonp([13651926962451],{

/***/ 1393:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"From Musician to Software Developer - Career Transition with Code Fellows' Ruby on Rails Boot Camp","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/from-musician-to-software-developer-career-transition-with-codefellows-ruby-on-rails-boot-camp","createdAt":"2013-11-08T04:14:21.776Z","blogAuthor":{"fields":{"name":"Mei Lu, Founder and CEO, Jobfully.com\t","slug":"blog/author/mei-lu-founder-and-ceo-jobfully-com"}},"imageHeader":null}}]},"authorJson":{"name":"Mei Lu, Founder and CEO, Jobfully.com\t","slug":"blog/author/mei-lu-founder-and-ceo-jobfully-com","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/mei-lu-founder-and-ceo-jobfully-com"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-mei-lu-founder-and-ceo-jobfully-com-a6b6d7ecf395c47a40bf.js